import { Injectable } from '@angular/core';

import { Aka } from '../../models/aka';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AkaService extends BackendBaseService {
  /**
   * Base URL for AKA resource
   * @type {String}
   */
  url = 'akas';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * CREATE and UPDATE actions for AKA resource
   * @param  {AKA} aka AKA to be saved
   * @return {Promise<any>} Save response
   */
  save(aka: Aka): Promise<any> {
    return super.save({
      contact_id: aka.contact_id,
      aka: aka,
      id: aka.id
    });
  }

  /**
   * Update positions of AKAs of a contact
   * @param  {number}           contactId Contact id
   * @param  {Array<number> =         []}          aka_ids AKA ids in order
   * @return {Promise<any>}               Server response
   */
  updatePositions(contactId: number, aka_ids: Array<number> = []): Promise<any> {
    return this.httpClient.put(`${this.url}/update_positions.json`, { contact_id: contactId, aka_ids: aka_ids });
  }
}
